'use client';

import { PropsWithChildren, useMemo } from 'react';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v16-appRouter';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import getTheme, { GetThemeProps } from './theme';

export type MuiProps = {
  fontRegistry: Record<string, string>;
  themeConfig: GetThemeProps;
  inPayload?: boolean;
};

export function MuiProvider({
  children,
  themeConfig,
  fontRegistry,
  inPayload,
}: PropsWithChildren<MuiProps>) {
  const theme = useMemo(
    () => getTheme(themeConfig, fontRegistry),
    [fontRegistry, themeConfig],
  );

  return (
    <AppRouterCacheProvider
      options={{ enableCssLayer: !inPayload, prepend: false }}
    >
      <ThemeProvider theme={theme}>
        {inPayload ? null : <CssBaseline />}
        {children}
      </ThemeProvider>
    </AppRouterCacheProvider>
  );
}
